import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { CustomerCooperationsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.CustomerCooperation };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    CustomerCooperationsActions.CreateCustomerCooperation,
    CustomerCooperationsActions.ReadCustomerCooperation,
    CustomerCooperationsActions.ReadCustomerCooperations,
    CustomerCooperationsActions.UpdateCustomerCooperation,
    CustomerCooperationsActions.DeleteCustomerCooperation,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    CustomerCooperationsActions.ReadCustomerCooperationSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false
      };
    }
  ),
  on(
    CustomerCooperationsActions.ReadCustomerCooperationsSuccess,
    (state, { response }) => {
      const fss = response['hydra:member'];
      const entities = fss.reduce(
        (
          entities: { [id: string]: fromModuleModels.CustomerCooperation },
          fs
        ) => {
          return {
            ...entities,
            [fs['@id']]: fs
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        errors: {},
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    CustomerCooperationsActions.CreateCustomerCooperationSuccess,
    CustomerCooperationsActions.UpdateCustomerCooperationSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        errors: {},
        loading: false
      };
    }
  ),
  on(
    CustomerCooperationsActions.DeleteCustomerCooperationSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        errors: {},
        loading: false
      };
    }
  ),
  on(
    CustomerCooperationsActions.CreateCustomerCooperationFail,
    CustomerCooperationsActions.ReadCustomerCooperationFail,
    CustomerCooperationsActions.ReadCustomerCooperationsFail,
    CustomerCooperationsActions.UpdateCustomerCooperationFail,
    CustomerCooperationsActions.DeleteCustomerCooperationFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
